'use strict';
const angular = require('angular');

export class mailComposerFilterSendComponent {
  /*@ngInject*/
  constructor(MailsService, SettingsService, CommunityService, PropertyService, DTOptionsBuilder) {

    this.SettingsService = SettingsService;
    this.MailsService = MailsService;
    this.CommunityService = CommunityService;
    this.PropertyService = PropertyService;

    this.filteredAvailableEmails = [];

    this.availableEmails = [];
    this.selectedEmails = [];

    this.filterPrimaryOwner = true;
    this.filterOwner = true;
    this.filterTenant = false;
    this.filterSecondOwner = false;

    this.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('order',  [0, 'asc']);

    this.CommunityService.query(data => {
      this.communities = [{
        value: undefined,
        name: '- All -'
      }].concat(data.map(cmty => {
        return {
          value: cmty._id,
          name: cmty.code + ": " + cmty.name
        };
      }));
    });

    this.PropertyService.queryWithContacts(data => {
      data.forEach(ppty => {
        ppty.contacts
          .filter(c => c.contact && c.contact.email && c.contact.email.length)
          .filter(c => c.type == 'primary-owner' || c.type == 'owner' || c.type == 'renter')
          .forEach(c => {
            c.contact.email.forEach(e => {
              let o = {
                firstName: c.contact.firstName,
                lastName: c.contact.lastName,
                middleName: c.contact.middleName,
                company: c.contact.company,
                community: ppty.community,
                lotNo: ppty.lotNo,
                buildingNo: ppty.buildingNo
              }

              o.type = {
                user: c.type,
                email: e.isPrimary ? "primary-email" : "other-email"
              };

              o.address = (ppty.address && ppty.address.street) ? ppty.address.street : "-";
              o.email = e.address;

              this.availableEmails.push(o);

            })
          })
      })

      this.applyFilter();

      this.dataInitComplete = true;
    })

  }

  resetCommunityFilter() {
    this.community = undefined;
    this.applyFilter();
  }

  applyFilter() {
    this.filteredAvailableEmails = this.availableEmails;

    if (this.community) {
      this.filteredAvailableEmails = this.filteredAvailableEmails.filter(o => o.community == this.community)
    }

    if (!this.filterPrimaryOwner) {
      this.filteredAvailableEmails = this.filteredAvailableEmails.filter(o => o.type.user != 'primary-owner');
    }

    if (!this.filterOwner) {
      this.filteredAvailableEmails = this.filteredAvailableEmails.filter(o => o.type.user != 'owner');
    }

    if (!this.filterTenant) {
      this.filteredAvailableEmails = this.filteredAvailableEmails.filter(o => o.type.user != 'renter');
    }

    if (!this.filterSecondOwner) {
      this.filteredAvailableEmails = this.filteredAvailableEmails.filter(o => o.type.email != 'other-email');
    }

  }

  selectEmail(email) {
    this.selectedEmails.push(email);
    this.availableEmails.forEach(o => {
      if (o.email == email)
        o.selected = true;
    })
    this.filteredAvailableEmails.forEach(o => {
      if (o.email == email)
        o.selected = true;
    })
  }

  selectAllAvailable() {
    this.filteredAvailableEmails.forEach(o => {
      o.selected = true;
      if (!this.selectedEmails.includes(o.email))
        this.selectedEmails.push(o.email);
    })
  }

  removeEmail(email) {
    this.selectedEmails = this.selectedEmails.filter(e => e != email);
    this.availableEmails.forEach(o => {
      if (o.email == email)
        o.selected = false;
    })
    this.filteredAvailableEmails.forEach(o => {
      if (o.email == email)
        o.selected = false;
    })
  }

  addIndividualEmail() {
    let email = window.prompt("Add another email:");
    if (email && email.trim() !== '') {
      if (!email.includes("@")) {
        alert("Not a valid email address");
        return;
      }
      this.selectedEmails.push(email);
      this.availableEmails.forEach(o => {
        if (o.email == email)
          o.selected = true;
      })
      this.filteredAvailableEmails.forEach(o => {
        if (o.email == email)
          o.selected = true;
      })
    }
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {
    let mail = this.config.mail;

    mail.recipients = this.selectedEmails;

    this.MailsService.send({id: mail._id}, mail, (res) => {
      this.close({$value: {mailId: mail._id}});
    }, (err) => {
      console.log("Could not send mail");
    });
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduu.mailComposerFilterSendComponent', [])
  .component('mailComposerFilterSendComponent', {
    template: require('./mail-composer-filter-send.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: mailComposerFilterSendComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/mail-composer-filter-send/mail-composer-filter-send.component.js